module.exports = __webpack_public_path__ + "img/aboutLogo.88cf8e73.png";